import { useState, useEffect, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { chatModesMap as staticChatModesMap } from "../config/chatModesMap";
import CHAT_MODES from "../constants/modes";
import { loadSystemContext, saveSystemContext } from "../utils/systemContext";

export function useChatbotScreen(modeFromUrl) {
    const [loading, setLoading] = useState(false);
    const [chatModesMap, setChatModesMap] = useState({});
    const [activeMode, setActiveMode] = useState("");
    const [isDarkTheme, setIsDarkTheme] = useState(() => {
        if (typeof window !== "undefined") {
            return (
                localStorage.getItem("theme") === "dark" ||
                (!localStorage.getItem("theme") &&
                    window.matchMedia("(prefers-color-scheme: dark)").matches)
            );
        }
        return false;
    });
    const [systemContext, setSystemContext] = useState({
        companyCode: "",
        regionCode: "",
        userCode: ""
    });
    const [showModal, setShowModal] = useState(false);
    const [searchParams] = useSearchParams();
    const ssidFromUrl = searchParams.get("SSID");



    // --- Handle SSID Decoding ---
    useEffect(() => {
        if (ssidFromUrl && ssidFromUrl.trim() !== "") {
            try {
                const decoded = JSON.parse(atob(ssidFromUrl));
                debugger;
                localStorage.setItem("designation", decoded.User_Type_Name || "");
                localStorage.setItem("User_Code", decoded.User_Code || "");
                localStorage.setItem("User_Type_Code", decoded.User_Type_Code || "");
                localStorage.setItem("Company", decoded.Company_Code || "");
                localStorage.setItem("LoginUser_name", decoded.UserName || decoded.User_Name || "");

                const newContext = {
                    companyCode: decoded.Company_Code || "",
                    regionCode: decoded.Region_Code || "",
                    userCode: decoded.User_Code || "",
                };

                setSystemContext(newContext);
                saveSystemContext(newContext);
            } catch (error) {
                console.error("Error decoding SSID:", error);
            }
        }
    }, [ssidFromUrl]);

    // --- Theme Handling ---
    useEffect(() => {
        if (isDarkTheme) {
            document.documentElement.classList.add("dark");
            localStorage.setItem("theme", "dark");
        } else {
            document.documentElement.classList.remove("dark");
            localStorage.setItem("theme", "light");
        }
    }, [isDarkTheme]);

    const toggleTheme = () => setIsDarkTheme(!isDarkTheme);

    // --- Chat Mode Loading ---
    const fetchInstances = useCallback(async () => {
        setLoading(true);
        try {
            setChatModesMap(staticChatModesMap);
            const availableModes = Object.keys(staticChatModesMap);

            if (availableModes.length > 0) {
                const priorityModes = [
                    CHAT_MODES.TYPE.HI_CRM,
                    CHAT_MODES.TYPE.HI_BRO,
                    CHAT_MODES.TYPE.UNIFIED,
                ];

                let selectedMode = availableModes[0];
                if (modeFromUrl) {
                    const matchedMode = availableModes.find(
                        (m) => m.toLowerCase() === modeFromUrl.toLowerCase()
                    );
                    if (matchedMode) selectedMode = matchedMode;
                } else {
                    selectedMode =
                        priorityModes.find((mode) =>
                            availableModes
                                .map((m) => m.toLowerCase())
                                .includes(mode.toLowerCase())
                        ) || availableModes[0];
                }

                setActiveMode(selectedMode);
            }
        } catch (error) {
            console.error("Error loading chat modes:", error);
        } finally {
            setLoading(false);
        }
    }, [modeFromUrl]);

    useEffect(() => {
        fetchInstances();
    }, [fetchInstances]);

    // --- Load persisted context ---
    useEffect(() => {
        const savedContext = loadSystemContext();
        setSystemContext(savedContext);
    }, []);


    return {
        loading,
        chatModesMap,
        activeMode,
        isDarkTheme,
        toggleTheme,
        systemContext,
        showModal,
        setShowModal,
    };
}
